export default async function ({ env, store, redirect }) {
  await store.dispatch('neo/fetchNeoToggles', [
    'mitra-change-phone-number-login',
    'mitra-change-phone-number-non-login',
  ]);
  const isUserLogin = store.getters['auth/isUserLoggedIn'];
  const toggleKey = isUserLogin ? 'mitra-change-phone-number-login' : 'mitra-change-phone-number-non-login';
  const isToggleOn = store.getters['neo/getNeoToggles'][toggleKey];
  if (!isToggleOn) return redirect(`${env.WEB_HOST}/faq`);
}
